import { LocalStorage } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ProfileService } from '../../shared/services/app/profile.service';
import { Component, OnInit, inject } from '@angular/core';
import { SessionService } from '../../shared/services/app/session.service';
import { AppService } from '../../shared/services/app/app.service';
import { MenuService } from '../../shared/services/menu/menu.service';
import { IMenu } from '../../shared/types/menu.type';
import { Logger } from '../../shared/services/logger/logger.service';
import { MENU } from '../menu';
import { ROUTE_AUTH, ROUTE_LOGOUT } from '../../shared/consts/routes.const';
import { UntilDestroy } from '@ngneat/until-destroy';
import { environment } from '../../../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-sidebar-layout',
  templateUrl: './sidebar-layout.component.html',
  styleUrls: ['./sidebar-layout.component.less'],
  standalone: false,
})
export class SidebarLayoutComponent implements OnInit {
  router = inject(Router);
  logger = inject(Logger);
  profileService = inject(ProfileService);
  session = inject(SessionService);
  appService = inject(AppService);
  menu = inject(MenuService);

  readonly environment = environment;

  /**
   * Свернутое меню
   */
  @LocalStorage('isCollapsed')
  isCollapsed!: boolean;
  /**
   * Меню
   */
  menuList$: BehaviorSubject<IMenu[]> = new BehaviorSubject<IMenu[]>([]);

  async ngOnInit() {
    await this.updateMenu();
  }

  private async updateMenu() {
    const filteredMenu = this.menu.filterMenu(MENU);
    this.menuList$.next(filteredMenu);
  }

  logout() {
    this.router.navigate([`${ROUTE_AUTH}/${ROUTE_LOGOUT}`]);
    return false;
  }
}
